// Creates a HSL color based of an email address.
// This is used to generate a consistent color for user avatars based on their email.
// Rather than using gravatars from Auth0 that might break CORS or require additional configuration
export function emailToColor(email: string): string {
  let hash = 0;

  for (let i = 0; i < email.length; i++) {
    hash = email.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = Math.abs(hash) % 360;

  return `hsl(${hue}, 70%, 60%)`;
}
